<!--
  侧栏菜单：router 模式，index 即跳转路径。
  菜单始终按展开宽度排版，收起成图标列靠外层裁切 + 文字淡出（见 layoutSidebar.css），
  展开和收回走同一条宽度动画；不用 el-menu 的 collapse，它先藏字再缩宽，收回会跳。
-->
<template>
  <el-menu
    ref="menu"
    :default-active="menuActive"
    class="menuContainer layoutSidebar__menu"
    :class="{ 'is-rail': collapsed }"
    unique-opened
    router
    @select="handleSelect"
  >
    <div
      class="layoutSidebar__brand"
      :class="{ 'is-collapsed': collapsed }"
      role="button"
      tabindex="0"
      @click="toggleSidebar"
      @keydown.enter.prevent="toggleSidebar"
      @keydown.space.prevent="toggleSidebar"
    >
      <span class="layoutSidebar__brandTitle">内容管理平台</span>
      <span class="layoutSidebar__brandMark">CMS</span>
    </div>
    <template v-for="item in list">
      <!-- 第一层 -->
      <div v-if="!item.hidden" :key="item.path">
        <el-submenu :index="item.path" v-if="item.children != undefined">
          <template slot="title">
            <i :class="item.meta.icon ? item.meta.icon : 'iconRight'"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <template v-for="item2 in item.children">
            <div v-if="!item2.hidden" :key="item2.path">
              <!-- 第二层 -->
              <el-submenu
                :index="item2.path"
                v-if="item2.children != undefined"
              >
                <template slot="title">
                  <i
                    :class="item2.meta.icon ? item2.meta.icon : 'iconRight'"
                  ></i>
                  <span slot="title"> {{ item2.name }}</span>
                </template>
                <template v-for="item3 in item2.children">
                  <div v-if="!item3.hidden" :key="item3.path">
                    <!-- 第三层 -->
                    <el-menu-item :index="item3.path">
                      <i
                        :class="item3.meta.icon ? item3.meta.icon : 'iconRight'"
                      ></i>
                      <span slot="title">{{ item3.name }}</span>
                    </el-menu-item>
                  </div>
                </template>
              </el-submenu>

              <el-menu-item :index="item2.path" v-else>
                <i :class="item2.meta.icon ? item2.meta.icon : 'iconRight'"></i>
                <span slot="title">{{ item2.name }}</span>
              </el-menu-item>
            </div>
          </template>
        </el-submenu>
        <el-menu-item :index="item.path" v-else>
          <i :class="item.meta.icon ? item.meta.icon : 'iconRight'"></i>
          <span slot="title"> {{ item.name }}</span>
        </el-menu-item>
      </div>
    </template>
  </el-menu>
</template>

<script>
export default {
  name: 'silder',
  props: {
    list: Array,
    /** 只剩图标列；展开的分组随之收起，否则子项会在窄栏里露半截 */
    collapsed: { type: Boolean, default: true }
  },

  watch: {
    collapsed(rail) {
      if (rail) {
        this.closeAllGroups()
      } else {
        // Element 初始化时同一个方法：重新展开当前页面所在的分组
        this.$refs.menu.initOpenedMenu()
      }
    },
    // 换页时 Element 会自动展开新页面的分组；图标列状态下要再收起
    menuActive() {
      if (this.collapsed) this.$nextTick(this.closeAllGroups)
    },
  },

  mounted() {
    if (this.collapsed) this.closeAllGroups()
  },

  methods: {
    closeAllGroups() {
      const menu = this.$refs.menu
      menu.openedMenus.slice().forEach((index) => menu.close(index))
    },
    /** 悬浮展开时点了菜单就该收回，交给 Layout 处理 */
    handleSelect() {
      this.$emit('navigate')
    },
    /** 与顶栏折叠按钮一致：固定 / 取消固定侧栏 */
    toggleSidebar() {
      this.$emit('toggle-pin')
    },
  },
  computed: {
    menuActive() {
      const matchPath = this.$route.matched
      const path=matchPath[matchPath.length - 1]
      const atcivePath=path.meta.activePath
      if(atcivePath){
        return atcivePath
      }else{
        return path.path
      }
    }
  }
}
</script>

<style scoped>
.menuContainer {
  height: 100%;
}
</style>
